











import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import User from "@/models/user/User";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import UserUpdateDialogAdditionalInfos from "@/components/user/UserUpdateDialogAdditionalInfos.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {UserUpdateDialogAdditionalInfos, AsiCardDetailEntry, AsiCardDetail}
})
export default class UserCardAdditionalInfos extends Vue {

	@Prop({type: Object, default: null})
	public user!: User | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('userChanged')
	public userChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
